<template>
  <div>
    <report-header @generate="load" @filterChanged="filterChanged"
      @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd" @onChangedGroup="onChangedGroup"
      :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged"
      @limitChanged="limitChanged"
      @download="download"
      @onChangeAccsGroup="onChangeAccsGroup"/>

    <basic-table
      @Filtred="Filtred"
      :items="sessions"
      :fields="sessionsFields"
      :filter="filter"
      :per-page="perPage"
      :current-page="currentPage"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
  </div>
</template>

<script>
import download from 'downloadjs'
export default {
  props: {
    userId: 0
  },
  data () {
    return {
      isGenerateDisabled: false,
      selectGroup: 0,
      selectAccsGroup: 0,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: this.$root.setDataWithSelectedTZ().toDate(),
      dateEnd: this.$root.setDataWithSelectedTZ().toDate(),
      filterOptions: {
        isFilterGroup: true,
        isFilterAccsGroup: true,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false,
        isDownloadable: true,
        hasLimitRows: true
      },
      getStore: {
        numDateEnd: 0,
        numDateStart: 0,
        userId: 0,
        group_id: 0,
        accs_group_id: 0,
        accounting_period_id: 0,
        limit: 500,
        download: 0
      },
      sessions: [],
      sessionsFields: [
        {key: 'id', label: this.$i18n.t('Session ID'), sortable: true},
        {key: 'account_id', label: this.$i18n.t('Account ID'), sortable: true},
        {key: 'recv_date', label: this.$i18n.t('Start date'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'last_update_date', label: this.$i18n.t('End date'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'called_station_id', label: this.$i18n.t('Called station'), sortable: true},
        {key: 'calling_station_id', label: this.$i18n.t('Calling station'), sortable: true},
        {key: 'framed_ip', label: this.$i18n.t('IP address'), sortable: true},
        {key: 'framed_ip6', label: this.$i18n.t('IP-address v6'), sortable: true},
        {key: 'nas_port', label: this.$i18n.t('NAS port'), sortable: true},
        {key: 'acct_session_id', label: this.$i18n.t('NAS session ID'), sortable: true},
        {key: 'uname', label: this.$i18n.t('Login'), sortable: true},
        {key: 'nas_ip', label: 'NAS IP', sortable: true},
        {key: 'status', label: this.$i18n.t('Status'), sortable: true},
        {key: 'acct_inp_oct', label: this.$i18n.t('Incoming bytes'), sortable: true},
        {key: 'acct_inp_giga', label: this.$i18n.t('Incoming gigabytes'), sortable: true},
        {key: 'acct_out_oct', label: this.$i18n.t('Outgoing bytes'), sortable: true},
        {key: 'acct_out_giga', label: this.$i18n.t('Outgoing gigabytes'), sortable: true},
        {key: 'acct_sess_time', label: this.$i18n.t('Duration'), sortable: true},
        {key: 'acct_term_cause', label: this.$i18n.t('Termination cause'), sortable: true},
        {key: 'total_cost', label: this.$i18n.t('Total cost'), sortable: true},
        {key: 'flags', label: this.$i18n.t('Telephony dialup/VPN flags'), sortable: true, formatter: (val, key, item) => { return this.flagsShow(Number(val)) }}
      ],
      ignoredSessionFlag: 1,
      droppedSessionFlag: 2,
      zeroChargeFlag: 4,
      IsgSessionFlag: 8
    }
  },
  methods: {
    Filtred (items) {
      this.totalRows = items.length
    },
    flagsShow (flag) {
      let result = ''
      if (flag & this.ignoredSessionFlag) {
        result += (this.$i18n.t('Ignore sessions time')) + ',\n'
      }
      if (flag & this.droppedSessionFlag) {
        result += (this.$i18n.t('Dropped')) + ',\n'
      }
      if (flag & this.zeroChargeFlag) {
        result += (this.$i18n.t('Zero charge')) + ',\n'
      }
      if (flag & this.IsgSessionFlag) {
        result += (this.$i18n.t('Isg sessions')) + ',\n'
      }
      result = result.slice(0, -2)
      return result
    },
    async load (isGenerateClick = true) {
      this.isGenerateDisabled = true
      let numDateEnd = Number(this.dateEnd) / 1000
      if (numDateEnd > 2147483647) numDateEnd = 2147483647
      let numDateStart = Number(this.dateStart) / 1000
      if (numDateStart > 2147483647) numDateStart = 2147483647
      this.getStore.numDateEnd = numDateEnd
      this.getStore.numDateStart = numDateStart
      if (!this.userId) {
        this.getStore.group_id = this.selectGroup
        this.getStore.accs_group_id = this.selectAccsGroup
      } else {
        this.getStore.userId = this.userId
      }
      await this.$store.dispatch('Reports/GET_SESSIONS', this.getStore).then(response => {
        if (isGenerateClick) {
          this.sessions = this.$store.getters['Reports/SESSIONS']
        } else {
          download(this.$store.getters['Reports/SESSIONS'], 'report_others_sessions.csv', 'text/csv')
        }
        for (let el of this.sessions) {
          switch (el.acct_status_type) {
            case 1:
              el.status = this.$i18n.t('Session start(reports)')
              break
            case 2:
              el.status = this.$i18n.t('Session closed(reports)')
              break
            case 3:
              el.status = this.$i18n.t('Session updated')
              break
          }
        }
        this.loadDone()
      })
      this.totalRows = this.sessions.length
      this.$emit('input', this.totalRows)
    },
    download () {
      this.getStore.download = 1
      this.load(false)
      this.$store.dispatch('Reports/CLEAR_CHANGE_LOG')
      this.getStore.download = 0
      this.totalRows = 0
      this.sessions = []
    },
    limitChanged (limit) {
      this.getStore.limit = limit
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    onChangedGroup (value) {
      this.selectGroup = (value)
    },
    onChangeAccsGroup (value) {
      this.selectAccsGroup = value
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  mounted () {
    this.loadDone()
    if (this.userId) {
      this.filterOptions.isFilterGroup = false
      this.filterOptions.isFilterAccsGroup = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reports/other/sessions/main.vue